<template>
    <div>
        <search-input
            ref="searchInput"
            v-model="user"
            autoSearch
            :finished="finished"
            :finished-text="sendType === 'rank' ? '' : '模糊搜索最多显示10条数据，可用更精准关键字查询。'"
            :loading="loading"
            :queryWhenInput="false"
            @load="onQuery"
            @onChange="onQuery(true)">
            <div
                @click="handleRightBtn"
                slot="rightBtn">搜索</div>
            <me-checkbox-group v-model="result" @change="changeGroup">
                <div
                    class="userInfo" v-for="(item,index) in userInfoList" :key="index">
                    <me-checkbox :name="item.rangeCode" shape="round" @click="onItemClick(item)" >
                        <div class="info-wrap">
                            <div class="name">
                                <span class="user-name">{{ item.rangeName }}</span>
                                {{&nbsp;&nbsp;}}
                                <span v-if="sendType !== 'rank'" :title="item.rangeCode" class="dept">{{ item.rangeCode }}</span>
                                {{&nbsp;&nbsp;}}
                                <span v-if="sendType === 'user'" class="dept">{{ item.deptName }}</span>
                            </div>
                        </div>
                    </me-checkbox>
                </div>
            </me-checkbox-group>
        </search-input>
        <confirm @confirm="confirm"/>
    </div>
</template>
<script>
import { Toast } from '@guazi-fe/melon'
import { Questionnaire } from '@/network'
import confirm from './confirm.vue'
export default {
    name: 'search',
    data() {
        return {
            userInfoList: [],
            user: '',
            loading: false,
            finished: false,
            result: [],
            interface: {
                dept: 'getDepts',
                user: 'getUser',
                rank: 'getRank'
            },
            checkedList: []
        }
    },
    watch: {
        value: {
            handler(newVal, oldVal) {
                this.result = newVal
            },
            immediate: true,
            deep: true
        },
        sendType: {
            handler(newVal, oldVal) {
                let obj = this.$store.state.rangeList.find(item => item.sendType === newVal)
                if (obj) {
                    this.checkedList = obj.rangeList || []
                } else {
                    this.checkedList = []
                }
                if (newVal === 'rank') {
                    this.$nextTick(()=>{
                        this.handleRightBtn()
                    })
                }
                if (newVal !== oldVal) {
                    this.user = ''
                    this.userInfoList = []
                }
            },
            immediate: true,
        }
    },
    model: {
        prop: 'value',
        event: 'changeGroup',
    },
    props: {
        sendType: {
            type: String,
            default: ''
        },
        value: {
            type: Array,
            default: (_) => [],
        },
    },
    components: {
        confirm
    },
    methods: {
        toggle(index) {
            this.$refs.checkboxes[index].toggle();
        },
        confirm() {
            this.checkedList = this.checkedList.map(item => {
                let obj = {...item}
                if (this.sendType === 'dept' && !obj.hasOwnProperty('isSubDept')) {
                    obj.isSubDept = true
                }
                return obj
            })
            this.$emit('confirm', this.checkedList, this.result.length === 0 ? '' : this.user)
        },
        getNetWorkParams() {
            let params = {}
            if (this.sendType === 'dept') {
                params = {
                    queryName: this.user,
                    state: 'A',
                    pageNum: 1,
                    pageSize: 10
                }
            } else if (this.sendType === 'user') {
                params = {
                    queryName: this.user,
                    status: '1',
                    type: '1',
                    pageNum: 1,
                    pageSize: 10
                }
            } else {
                params = {
                    rankCode: this.user,
                    tid: this.tid
                }
            }
            return params
        },
        getNetWorkRes(list = []) {
            let res = []
            if (this.sendType === 'dept') {
                res = list.map(item => ({rangeCode: item.id, rangeName: item.name}))
            } else if (this.sendType === 'user') {
                res = list.map(item => ({rangeCode: item.empId, rangeName: item.name, deptName: item.deptName}))
            } else {
                res = list.map(item => ({rangeCode: item, rangeName: item}))
            }
            return res
        },
        onQuery(isReset) {
            if (!this.user && this.sendType !== 'rank') {
                Toast.fail('请输入搜索内容')
                return
            }
            if (isReset) {
                this.userInfoList = []
            }
            this.loading = true
            let params = this.getNetWorkParams()
            Questionnaire[this.interface[this.sendType]](params).then((res) => {
                const { data: { data } } = res
                this.userInfoList = this.getNetWorkRes(data)
                this.loading = false
                this.finished = true
            })
        },
        handleRightBtn() {
            this.$refs.searchInput.doSearch()
        },
        onItemClick(item) {
            let checked = this.result.indexOf(item.rangeCode) !== -1
            if (checked) {
                this.checkedList.push({...item})
            } else {
                let index = this.checkedList.findIndex(i => i.rangeCode === item.rangeCode)
                this.checkedList.splice(index, 1)
            }
        },
        changeGroup() {
            this.$emit('changeGroup', this.result)
        }
    }
}
</script>
<style scoped lang="scss">
    .userInfo {
        padding: 4px 0 5px 10px;
        margin-bottom: 8px;
        list-style: none;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 400;
        color: #424B58;
        line-height: 20px;
        cursor: pointer;
        color: #9298A8;
        .info-wrap{
            display: flex;
        }
        .usercode{
            // flex:1;
            text-align:right;
            padding-right:8px;
            box-sizing: border-box;
        }
        .name{
            flex:1;
            .user-name{
                height: 14px;
                font-size: 14px;
                font-weight: 400;
                color: #424b58;
            }
        }
        .persion-item{
            display: block;
        }
        .dept{
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 244px;
            overflow: hidden;
        }
    }
</style>